import { EVENT_PRODUCER_NAME } from '@web-platform/shared-acorn-constants/src/miniEvents';
import { FunnelEventsTracking } from 'saddlebag-user-tracking-events';

import type {
  FunnelEventProperty,
  FunnelEventEventName,
} from '@web-platform/shared-universal-types-tracking/src/funnelEvents/funnelEventsTypes';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

const tracker = new FunnelEventsTracking('public', EVENT_PRODUCER_NAME);

export const track = (
  eventName: FunnelEventEventName,
  funnelDimensions: FunnelEventProperty = {},
  opts?: { messageGuid?: Nullable<string>; [key: string]: unknown },
): void => {
  tracker.track(eventName, funnelDimensions, opts);
};
